<template>
    <div class="body-panel">
        <div class="form-modal-body">

            <div class="row">
                <b-field style="width: 50%" label="Enter Old Password">
                    <b-input type="password" v-model="form.oldPassword" value=""></b-input>
                </b-field>
            </div>


            <div class="row" style="margin-top: 30px;">
                <b-field style="width: 50%" label="New Password">
                    <b-input type="password" v-model="form.newPassword" value=""></b-input>
                </b-field>
            </div>


            <div class="row">
                <b-field style="width: 50%" label="Re-Enter New Password">
                    <b-input type="password" v-model="form.reNewPassword" value=""></b-input>
                </b-field>
            </div>

            <div class="nb">
                Changes will take effect after you save them and signout and sign
                back in.
            </div>
        </div>
        <div class="form-optional-panel">
            <b-button :loading="submit_loading" @click="updateAccountSecurity" type="is-primary">UPDATE PASSWORD</b-button>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    sockets: {},
    data: () => ({
        form: {
            oldPassword: "",
            newPassword: "",
            reNewPassword: ""
        },
        submit_loading: false,
    }),
    watch: {},
    mounted() {
        let vm = this;
    },
    methods: {
        updateAccountSecurity() {
            let vm = this;
            const rules = {
                oldPassword: {
                    run: (value) => {
                        if (!value) {
                            return "Old password can not be empty";
                        }
                        return false;
                    },
                },
                newPassword: {
                    run: (value) => {
                        if (!value) {
                            return "New password can not be empty";
                        }
                        return false;
                    },
                },
                reNewPassword: {
                    run: (value) => {
                        if (!value) {
                            return "Re-enter new password can not be empty";
                        } else if (value != vm.form.newPassword) {
                            return "New password and re-enter new password must be same";
                        }
                        return false;
                    },
                }
            };
            if (vm.$isFieldsValidated(vm.form, rules)) {
                vm.submit_loading = true;
                vm.$store
                    .dispatch("ADMIN_USER_UPDATE_PASSWORD", vm.form)
                    .then((response) => {
                        vm.submit_loading = false;
                        vm.$emit("saved");
                        vm.$notify({
                            group: "status",
                            type: "success",
                            title: "Important message",
                            text: response.data.message,
                        });
                    })
                    .catch(({ response }) => {
                        vm.submit_loading = false;
                        vm.$notify({
                            group: "status",
                            type: "warn",
                            title: "OOPS!!!",
                            text: response.data.message,
                        });
                    });
            }
        },

    },
};
</script>

<style lang="scss" scoped>
.body-panel {
    height: calc(100% - 55px);


    .form-modal-body {
        display: flex;
        flex-direction: column;
        height: calc(100% - 70px);
        padding: 20px;
        overflow-y: auto;

        .nb {
            font-size: 12px;
            color: #999;
            margin-top: 30px;
        }
    }


    .form-optional-panel {
        height: 70px;
        border-top: 1px solid #ddd;
        display: flex;
        align-items: center;
        padding: 0px 20px;
    }
}
</style>